import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import Button from 'tfs.button'
import Icon from 'tfs.icon'
import classNames from 'classnames'

import getLabels from '../../utils/getLabels'

class BulkUpload extends Component {
  state = {
    fileName: getLabels('select_csv'),
  }

  updateFileName = files => {
    if (!files || !files.length) {
      this.setState({ fileName: getLabels('select_csv') })

      return
    }

    this.setState({
      fileName: files[0].name,
    })
  }

  handleChange = event => {
    this.updateFileName(event.target.files)
  }

  render() {
    const { classes, onSubmit, inputRef, isDisabled, location } = this.props
    const { fileName } = this.state

    const hanldeSubmit = (e) => {
      onSubmit(e, location.search)
    }

    return (
      <form className={classes.wrapper} onSubmit={hanldeSubmit}>
        <input
          type="file"
          id="bulk-upload"
          ref={inputRef}
          name="bulk-upload"
          accept=".csv"
          className={classes.input}
          onChange={this.handleChange}
          disabled={isDisabled}
        />

        <label className={classes.label} htmlFor="bulk-upload">
          <div className={classes.displayLabel}>
            {getLabels('upload_csv_file_title')}
          </div>
          <div
            className={classNames(classes.upload, {
              [classes.disabled]: isDisabled,
            })}
          >
            <span className={classes.uploadIcon}>
              <Icon name="upload" />
            </span>
            <span>{fileName}</span>
          </div>
        </label>

        <span className={classes.buttonWrapper}>
          <Button
            type="submit"
            className={classes.submit}
            isDisabled={isDisabled}
            data-element="submit-csv-file"
          >
            {getLabels('upload_csv_file_button')}
          </Button>
        </span>
      </form>
    )
  }
}

BulkUpload.propTypes = {
  classes: PropTypes.shape({
    wrapper: PropTypes.string,
    label: PropTypes.string,
    displayLabel: PropTypes.string,
    input: PropTypes.string,
    buttonWrapper: PropTypes.string,
    upload: PropTypes.string,
    uploadIcon: PropTypes.string,
  }),
  onSubmit: PropTypes.func,
  inputRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
}

export default withRouter(BulkUpload)
